import React from "react";
import { Typography, Box } from "@mui/material";
import moment from "moment";

interface DateDisplayProps {
  timestamp: number;
  format?: string;
  variant?: "body1" | "body2" | "caption" | "subtitle1" | "subtitle2";
  fontWeight?: number | string;
  color?: string;
  showTooltip?: boolean;
  tooltipFormat?: string;
}

export const DateDisplay: React.FC<DateDisplayProps> = ({
  timestamp,
  format = "MMM DD, YYYY",
  variant = "body2",
  fontWeight = 500,
  color,
  showTooltip = false,
  tooltipFormat = "dddd, MMMM DD, YYYY [at] h:mm A",
}) => {
  const formattedDate = moment(timestamp).format(format);
  const tooltipDate = moment(timestamp).format(tooltipFormat);

  if (showTooltip) {
    return (
      <Box component="span" title={tooltipDate} sx={{ cursor: "help" }}>
        <Typography
          variant={variant}
          sx={{
            fontWeight,
            color: color || "text.primary",
            fontFamily: "monospace",
          }}
        >
          {formattedDate}
        </Typography>
      </Box>
    );
  }

  return (
    <Typography
      variant={variant}
      sx={{
        fontWeight,
        color: color || "text.primary",
        fontFamily: "monospace",
      }}
    >
      {formattedDate}
    </Typography>
  );
};
